import * as CSS from 'csstype';
import styled, { css, keyframes } from 'styled-components';
import { borders, colors, spaces } from '@99designs/emu/settings';

export const pulseKeyframes = keyframes`
    0% {
        background-color: ${colors.grey100}
    }

    30% {
        background-color: ${colors.grey200}
    }

    100% {
        background-color: ${colors.grey100}
    }
`;

export interface SkeletonBlockProps {
    headingLevel?: number;
    inline?: boolean;
    width?: CSS.Property.Width<string | 0>;
}

const SkeletonBlock = styled.div<SkeletonBlockProps>`
    min-width: ${spaces['8bu']};
    display: block;
    min-height: ${spaces['1bu']};
    margin-bottom: ${spaces['0.25bu']};
    border-radius: ${borders.borderRadiuses.small}px;
    animation: ${pulseKeyframes} 1s infinite 0.2s;

    ${({ headingLevel }) => {
        switch (headingLevel) {
            case 4:
                return css`
                    width: ${spaces['2bu']};
                    margin-bottom: ${spaces['1bu']};
                `;
            case 5:
                return css`
                    width: ${spaces['1.5bu']};
                    margin-bottom: ${spaces['0.75bu']};
                `;
            default:
                return ``;
        }
    }}

    ${({ inline }) =>
        inline &&
        css`
            display: inline-block;
            margin-right: ${spaces['0.75bu']};
        `}

    ${({ width }) =>
        width &&
        css`
            width: ${width};
        `}
`;

export default SkeletonBlock;
